import { render } from "./mmapsearch.vue?vue&type=template&id=ff702774&scoped=true"
import script from "./mmapsearch.vue?vue&type=script&lang=js"
export * from "./mmapsearch.vue?vue&type=script&lang=js"

import "./mmapsearch.vue?vue&type=style&index=0&id=ff702774&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff702774"]])

export default __exports__